import {match} from 'ts-pattern';

import type {DefinitionWithTemplatesResponseBody} from '@dms/api/core';

import type {CheckoutProfileFormValues} from '../types/CheckoutProfileFormValuesSchema';

export function getCheckoutProfileTemplateOptions(
  definitions: DefinitionWithTemplatesResponseBody[],
  typeOfSale: CheckoutProfileFormValues['typeOfSale'],
  documentType: CheckoutProfileFormValues['documents'][number]['documentType']
) {
  const internal = typeOfSale === 'INTERNAL';
  const code = match(documentType)
    .with('INVOICE', () => (internal ? 'workshop-invoice_internal' : 'workshop-invoice'))
    .with('CORRECTIVE_INVOICE', 'CORRECTIVE_TAX_DOCUMENT', () =>
      internal ? 'workshop-internal_corrective_tax_document' : 'workshop-corrective_tax_document'
    )
    .with('DEPOSIT_INVOICE', () => 'workshop-invoice_proforma')
    .with('TAX_DOCUMENT', () => 'workshop-tax_document_for_payment')
    .exhaustive();

  return definitions
    .filter(
      (definition) =>
        definition.group === 'workshop' &&
        definition.type === 'html' &&
        definition.documentCode === code
    )
    .flatMap((definition) =>
      definition.templates
        .filter((template) => !template.isHidden)
        .map((template) => ({value: template.id, label: template.title}))
    );
}
